import React from "react";
import "./input.css";

export default ({
  name,
  type,
  nameFontSize,
  inputFontSize,
  error,
  inputChange,
  value,
  maxLength
}) => {
  return (
    <div className="input_container">
      <span style={{ fontSize: nameFontSize || '16px', paddingTop: '0' }}>{name}</span>
      <input
        style={{ fontSize: inputFontSize || '16px' }}
        type={type}
        onChange={inputChange}
        value={value}
        maxLength={maxLength || '250'}
      />
      <span style={{ color: "red", display: error ? "flex" : "none", paddingBottom: '0' }}>
        {error}
      </span>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/input/input-component.js